// NC 가 쓴 저장소 키 기록(public/nc-storage-guard.js 가 NC 문서 안에서 남긴다)을 최상위 창에서 읽어 지운다.
// 🔴 왜: fetch 로 부르는 NC 로그아웃(ncSso.logoutNcSession · gatewayLogout)은 NC 문서를 띄우지 않아
//    보호 스크립트도 NC 의 clear 코드도 돌지 않는다. nginx 가 로그아웃 응답의 Clear-Site-Data 를 떼므로
//    앞 사용자가 NC 에서 쓴 키(예: Talk 초안)를 지우는 주체가 없다 → 그 fetch 뒤에 여기서 지운다.
// 🔴 기록된 이름 중 KEEP 밖만 지운다. 기록에 없는 키(게이트웨이 키 전부)는 건드리지 않는다.
//    Storage.prototype 은 건드리지 않는다(최상위 창에는 보호 스크립트가 없다).
// 🔴 축 쌍: 아래 기록 키 이름·KEEP 목록은 public/nc-storage-guard.js 에도 있다(번들 밖이라 import 불가) —
//    한쪽만 고치면 어긋난다. ncStorageGuard.test.js (h) 가 두 파일의 값이 같은지 단언한다.
export const RECORD_KEY_LOCAL = '__aigwNcKeys:local';
export const RECORD_KEY_SESSION = '__aigwNcKeys:session';
export const KEEP_LOCAL = ['token', 'user', 'gwLoggedOut'];
export const KEEP_SESSION = [];

const RECORD_PREFIX = '__aigwNcKeys:';

function storageOf(kind) {
  try {
    if (kind === 'local') return typeof localStorage === 'undefined' ? null : localStorage;
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch (e) {
    return null;
  }
}

// 한 저장소분. 기록이 없거나 깨졌으면(배열 아님) 아무것도 지우지 않는다. 실패는 삼킨다.
function clearOne(kind, recordKey, keep) {
  const storage = storageOf(kind);
  if (!storage) return;
  let names = null;
  try {
    const parsed = JSON.parse(storage.getItem(recordKey));
    if (Array.isArray(parsed)) names = parsed.filter((n) => typeof n === 'string');
  } catch (e) {
    names = null;
  }
  if (!names) return;
  names.forEach((name) => {
    if (name.startsWith(RECORD_PREFIX) || keep.includes(name)) return;
    try { storage.removeItem(name); } catch (e) { /* 다음 이름으로 */ }
  });
  try { storage.removeItem(recordKey); } catch (e) { /* */ }
}

// 한쪽 저장소가 실패해도 다른 쪽은 계속한다.
export function clearRecordedNcStorage() {
  try { clearOne('local', RECORD_KEY_LOCAL, KEEP_LOCAL); } catch (e) { /* */ }
  try { clearOne('session', RECORD_KEY_SESSION, KEEP_SESSION); } catch (e) { /* */ }
}
